import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Tile from 'components/shared/Tile/Tile'
import { addTestIdProp, addIdProp } from 'utils/universal'
import sx from './styles'

const ValueProposal = (props) => {
  const {
    items = [], title, disclaimer, testId: testIdProp, customRef,
  } = props
  const renderFeature = (feature, i) => (
    <Grid
      key={`feature-idx-${i}`}
      size={{
        xs: 12,
        sm: 6,
        md: 4,
        lg: 4,
      }}
    >
      <Tile
        sx={sx.tile}
        icon={feature.icon}
        variant="row"
        text={(
          <>
            <Typography
              align="center"
              variant="h4"
              component="div"
              sx={sx.line1}
            >
              {feature.line1}
            </Typography>
            <Typography
              align="center"
              variant="body1"
              component="div"
              sx={sx.line2}
            >
              {feature.line2}
            </Typography>
          </>
        )}
      />
    </Grid>
  )
  return (
    <Box
      {...addTestIdProp(testIdProp)}
      {...addIdProp(testIdProp)}
      ref={customRef}
      sx={sx.root}
    >
      <Container
        maxWidth="lg"
        sx={sx.valueContainer}
      >
        <Grid
          container
          alignItems="start"
          sx={sx.bgContainer}
        >

          {title && (
            <Grid
              size={{
                xs: 12,
                lg: 3,
              }}
            >
              <Typography
                variant="h3"
                sx={sx.title}
              >
                <FormattedMessage id={title} />
              </Typography>
            </Grid>
          )}

          <Grid
            size={{
              xs: 12,
              lg: 9,
            }}
            sx={sx.featureContainer}
          >
            <Grid container>
              {items && items.length > 0 && items.map(renderFeature)}
            </Grid>
          </Grid>

          {disclaimer && (
            <Grid
              size={12}
              mt={3}
            >
              <Typography
                variant="body2"
                sx={sx.disclaimer}
              >
                <FormattedMessage id={disclaimer} />
              </Typography>
            </Grid>
          )}

        </Grid>
      </Container>
    </Box>
  )
}

export default memo(ValueProposal)
